<template>
  <div class="result-block-broker-app p-relative">
    <div class="offers-heading">
      <div>
        <div class="offers-heading__title">Výsledky bánk</div>
        <div class="offers-heading__description">Porovnanie dostupných ponúk podľa zadaného financovania.</div>
      </div>
      <div class="offers-heading__count">{{ successfulOffersCount }} ponúk</div>
    </div>
    <div class="quick-offer-settings">
      <div class="quick-offer-settings__intro">
        <strong>Rýchle nastavenia ponúk</strong>
        <span>Uplatnia sa naraz vo všetkých bankách, ktoré danú úpravu podporujú.</span>
      </div>
      <button
        type="button"
        class="quick-setting-button"
        :class="{'quick-setting-button--active': isLtv90Active}"
        :disabled="true"
        title="LTV a jeho prirážka sa vyhodnotia automaticky až po zadaní hodnoty zakladanej nehnuteľnosti."
      >
        <span class="quick-setting-button__status">{{ isLtv90Active ? '✓' : '+' }}</span>
        <span>
          <strong>90 % LTV</strong>
          <small>{{ hasKnownLtv ? 'automaticky podľa LTV' : 'bez nehnuteľnosti – bez prirážky' }}</small>
        </span>
      </button>
      <button
        type="button"
        class="quick-setting-button"
        :class="{'quick-setting-button--active': usesBankAccount}"
        :disabled="quickSettingsLoading"
        title="Nastaví použitie účtu a hromadne upraví súvisiace zmeny sadzieb."
        @click="toggleBankAccount"
      >
        <span class="quick-setting-button__status">{{ usesBankAccount ? '✓' : '+' }}</span>
        <span>
          <strong>Účet v banke</strong>
          <small>{{ usesBankAccount ? 'použije sa' : 'bez účtu' }}</small>
        </span>
      </button>
      <button
        v-for="product in insuranceProducts"
        :key="product.field"
        type="button"
        class="quick-setting-button"
        :class="{'quick-setting-button--active': mortgageGetter[product.field]}"
        :disabled="quickSettingsLoading"
        :aria-pressed="Boolean(mortgageGetter[product.field])"
        :title="'Automaticky započíta dostupné zľavy za tento produkt vo všetkých bankách.'"
        @click="toggleInsuranceProduct(product)"
      >
        <span class="quick-setting-button__status">{{ mortgageGetter[product.field] ? '✓' : '+' }}</span>
        <span><strong>{{ product.label }}</strong><small>{{ mortgageGetter[product.field] ? 'použije sa' : 'bez poistenia' }}</small></span>
      </button>
      <v-progress-circular
        v-if="quickSettingsLoading"
        class="loading-spinner extrasmall"
        indeterminate
      ></v-progress-circular>
    </div>
    <div class="results-legend" :class="{'sticky': isSticky}" ref="resultNavbar" id="resultNavbar">
      <div
        class="break-40px"
      ></div>
      <!-- vyska uveru -->
      <div
        class="text-small wrap-100px flex-row-10px sort-button pointer"
        @click="sortOffersBy('pozicana_suma')"
      >
        <span>
          Celkom
        </span>
        <img
          alt=""
          src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg"
          :class="[ascending ? 'rotate-up display-sort filter-primary' : 'rotate-down display-sort filter-primary']"
        />
      </div>
      <!-- fixacia -->
      <fixation-choose-handler :rules="['priority']" :title="'Fixácia'"/>
      <!-- sadzba  -->
      <div
        class="text-small wrap-50px flex-row-10px sort-button pointer"
        @click="sortOffersBy('sadzba')"
      >
        <span>
          Sadzba
        </span>
        <img
          alt=""
          src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg"
          :class="[ascending ? 'rotate-up display-sort filter-primary' : 'rotate-down display-sort filter-primary']"
        />
      </div>
      <!-- splatka -->
      <div
        class="text-small wrap-100px flex-row-10px sort-button pointer"
        @click="sortOffersBy('mesacna_splatka')"
      >
        <span>
          Splátka
        </span>
        <img
          alt=""
          src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg"
          :class="[ascending ? 'rotate-up display-sort filter-primary' : 'rotate-down display-sort filter-primary']"
        />
      </div>
      <!-- splatnost -->
      <div
        class="text-small wrap-50px flex-row-10px sort-button pointer"
        @click="sortOffersBy('splatnost_r')"
      >
        <span>
          Splatnosť
        </span>
        <img
          alt=""
          src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg"
          :class="[ascending ? 'rotate-up display-sort filter-primary' : 'rotate-down display-sort filter-primary']"
        />
      </div>
      <!-- poplatok -->
      <div
        class="text-small wrap-50px flex-row-10px sort-button pointer"
        @click="sortOffersBy('popl_sprac_hypo')"
      >
        <span>
          Poplatok
        </span>
        <img
          alt=""
          src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg"
          :class="[ascending ? 'rotate-up display-sort filter-primary' : 'rotate-down display-sort filter-primary']"
        />
      </div>
    </div>
    <div v-if="pickedApplications?.length !== 0">
      <mortgage-application-item-picked
        v-for="(application, applicationIndex) in pickedApplications"
        v-if="application.stage !== 'zrusena'"
        :key="applicationIndex"
        :application="application"
        :pre-picked="true"
      />
      <hr>
    </div>
    <div class="limits-loader" v-if="loading">
    <span class="blc-color MGright20px">prepočítavame možné ponuky financovania</span>
    <v-progress-circular
      class="loading-spinner small transparent"
      indeterminate
    ></v-progress-circular>
    </div>
    <mortgage-application-choice-item
      v-else
      v-for="offer in mortgageOffersData"
      :key="offer.bankKey"
      :offer="offer"
      :bank-key="offer.extra.bank_code_name"
    />
    <div
      v-if="showEmptyOffersState"
      class="offers-empty-state"
      :class="{'offers-empty-state--error': hasOffersError}"
      role="status"
      aria-live="polite"
    >
      <div class="offers-empty-state__icon">{{ hasOffersError ? '×' : '!' }}</div>
      <div class="offers-empty-state__content">
        <span v-if="hasOffersError" class="offers-empty-state__eyebrow">Technická chyba výpočtu</span>
        <strong>{{ emptyOffersTitle }}</strong>
        <p>{{ emptyOffersMessage }}</p>
        <ul v-if="limitReasons.length">
          <li v-for="reason in limitReasons" :key="reason">{{ reason }}</li>
        </ul>
        <button
          v-if="hasOffersError"
          type="button"
          class="offers-empty-state__retry"
          :disabled="loading"
          @click="retryOffers"
        >
          Prepočítať ponuky znova
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MortgageApplicationChoiceItem from "./MortgageApplicationChoiceItem";
import FixationChooseHandler
  from "../../../../shared/PopupHandler/Popups/FixationChoose/FixationChooseHandler.vue";
import {mapGetters} from "vuex";
import MortgageApplicationItemPicked from "./MortgageApplicationItemPicked";
import {patchMortgage} from "@/services/brokerService";

export default {
  name: "MortgageApplicationsWrapper",
  components: {
    MortgageApplicationItemPicked,
    FixationChooseHandler,
    MortgageApplicationChoiceItem,
  },
  props: {
    mortgage: Object,
    mortgageOffers: Array,
  },
  computed: {
    successfulOffersCount () {
      return (this.mortgageOffersData || []).filter((offer) => offer.success).length;
    },
    ...mapGetters({
      offersDataGetter: "mortgageDetailState/getOffersData",
      offersLoading: "appState/getOffersLoading",
      mortgageGetter: "mortgageDetailState/getMortgage",
      ratesGetter: "mortgageDetailState/getAppliedMortgageRateChanges",
      amountsGetter: "mortgageDetailState/getAmounts",
      loanLimitGetter: "mortgageDetailState/getLoanLimit",
      limitsGetter: "mortgageDetailState/getLimits",
      offersErrorGetter: "mortgageDetailState/getOffersError",
    }),
    totalRequestedAmount () {
      return Object.values(this.amountsGetter || {}).reduce(
        (total, value) => total + Number(value || 0),
        0,
      );
    },
    showEmptyOffersState () {
      return !this.loading && (!Array.isArray(this.mortgageOffersData) || this.mortgageOffersData.length === 0);
    },
    hasOffersError () {
      return this.totalRequestedAmount > 0 && Boolean(this.offersErrorGetter);
    },
    currentPurpose () {
      const amounts = this.amountsGetter || {};
      const purposes = [
        ["nadobudnutie", Number(amounts.suma_nadobudnutie || 0)],
        ["refinancovanie", Number(amounts.suma_refinancovanie || 0)],
        ["bezucel", Number(amounts.suma_bezucel || 0)],
      ];
      purposes.sort((a, b) => b[1] - a[1]);
      return purposes[0][1] > 0 ? purposes[0][0] : "nadobudnutie";
    },
    emptyOffersTitle () {
      if (this.hasOffersError) return "Ponuky sa momentálne nepodarilo prepočítať";
      if (this.totalRequestedAmount === 0 && Number(this.loanLimitGetter || 0) <= 0) {
        return "Ponuky sa nedajú vypočítať – úverový limit je 0 EUR";
      }
      if (this.totalRequestedAmount === 0) return "Nie je zadaná výška úveru";
      return "Pre zadané financovanie sa nenašli ponuky";
    },
    emptyOffersMessage () {
      if (this.hasOffersError) return this.offersErrorGetter;
      if (this.totalRequestedAmount === 0 && Number(this.loanLimitGetter || 0) <= 0) {
        return "Preto sa nedá potiahnuť ani jeden posuvník. Skontrolujte aktívne a bankou akceptované príjmy, bonitu, výdavky a záväzky žiadateľa aj spolužiadateľa.";
      }
      if (this.totalRequestedAmount === 0) {
        return "Nastavte sumu v časti Rozdelenie úveru podľa účelu. Po zadaní sumy sa ponuky bánk prepočítajú automaticky.";
      }
      return this.offersErrorGetter || "Banky pre aktuálnu sumu, účel, splatnosť a zadané údaje nevrátili použiteľnú ponuku.";
    },
    limitReasons () {
      if (this.totalRequestedAmount !== 0 || Number(this.loanLimitGetter || 0) > 0) return [];
      const reasons = new Set();
      for (const bankLimits of Object.values(this.limitsGetter || {})) {
        const limit = bankLimits?.[this.currentPurpose];
        if (!limit || Number(limit.value || 0) > 0) continue;
        for (const detail of limit.details || []) {
          if (detail) reasons.add(detail);
        }
        if (Number(limit?.extra?.dti || limit?.podla_dti?.value || 0) <= 0) {
          reasons.add("DTI limit po zohľadnení akceptovaných príjmov a záväzkov je nulový.");
        }
        if (Number(limit?.extra?.dsti || limit?.podla_dsti_a_splatnosti?.value || 0) <= 0) {
          reasons.add("Dostupná mesačná splátka podľa DSTI je nulová.");
        }
      }
      return [...reasons].slice(0, 4);
    },
    allAvailableRateChanges () {
      const changesById = new Map();
      for (const offer of this.mortgageOffersData || []) {
        for (const change of offer?.extra?.mozne_zmeny_sadzieb || []) {
          changesById.set(change.id, change);
        }
      }
      return [...changesById.values()];
    },
    ltv90Changes () {
      return this.allAvailableRateChanges.filter((change) => change.typ === "ltv_vyssie_80");
    },
    accountChanges () {
      // Older data used `ucet_v_banke`; current API calls the same account
      // condition `nevyuzity_ucet_v_banke`. Both represent the rate change
      // applied when the client actively uses the bank account.
      return this.allAvailableRateChanges.filter((change) => (
        change.typ === "ucet_v_banke" || change.typ === "nevyuzity_ucet_v_banke"
      ));
    },
    hasAutomaticLtv90 () {
      return (this.mortgageOffersData || []).some((offer) => (
        offer?.extra?.ltv_90_prirazka?.applied
        && offer.extra.ltv_90_prirazka.source === "automatic"
      ));
    },
    isManualLtv90Active () {
      if (this.ltv90Changes.length === 0) return false;
      const selected = new Set(this.ratesGetter || []);
      return this.ltv90Changes.every((change) => selected.has(change.id));
    },
    hasKnownLtv () {
      return (this.mortgageOffersData || []).some(offer => offer?.extra?.ltv_90_prirazka?.requested_ltv != null);
    },
    isLtv90Active () {
      return this.hasAutomaticLtv90;
    },
    insuranceProducts () {
      return [
        {field: "poistenie_uveru_v_banke", type: "poistenie_uveru_v_banke", label: "Poistenie úveru"},
        {field: "poistenie_nehnutelnosti_v_banke", type: "poistenie_nehnutelnosti_v_banke", label: "Poistenie nehnuteľnosti"},
      ];
    },
    usesBankAccount () {
      return Boolean(this.mortgageGetter?.vyuzitie_uctu_od_banky);
    },
  },
  watch: {
    mortgageOffers (newApplications) {
      this.mortgageOffersData = this.getSortedOffers(newApplications, this.sortParameter, !this.ascending);
    },
    mortgage (newMortgage) {
      this.pickedApplications = newMortgage.applications;
    },
    offersLoading (value) {
      this.loading = value;
    },
    offersDataGetter () {
      this.$store.dispatch("mortgageDetailState/fetchOffers", this.mortgage.id);
    },
  },
  created () {
    this.pickedApplications = this.mortgage.applications;
    this.mortgageOffersData = (JSON.parse(JSON.stringify({offers: this.mortgageOffers}))).offers;
    const sorter = setInterval(() => {
      if (!this.loading) {
        this.sortOffersBy("pozicana_suma");
        clearInterval(sorter);
      }
    }, 500);
  },
  mounted() {
    this.loading = this.$store.getters["appState/getOffersLoading"];
    this.navbarOffset = this.$refs.resultNavbar.offsetTop;
    // Add the scroll event listener
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy () {
    if (!this.mortgageOffersData || this.mortgageOffersData.length === 0) return;
    this.createHistoryObject();
  },
  methods: {
    retryOffers() {
      this.$store.dispatch("mortgageDetailState/fetchOffers", this.mortgage.id);
    },
    async saveQuickSettings(object, successText) {
      this.quickSettingsLoading = true;
      try {
        await this.$store.dispatch("mortgageDetailState/patchMortgage", {
          id: this.mortgage.id,
          object,
        });
        const stored = this.$store.getters["mortgageDetailState/getMortgage"] || {};
        if (Object.entries(object).some(([key, value]) => typeof value === "boolean" && Boolean(stored[key]) !== value)) {
          throw new Error("Produkt nebol uložený.");
        }
        await this.$store.dispatch("mortgageDetailState/fetchOffers", this.mortgage.id);
        this.$store.commit("appState/setSuccessMessage", {
          text: successText,
          type: "success",
        });
      } catch (error) {
        this.$store.commit("appState/setSuccessMessage", {
          text: "Hromadné nastavenie sa nepodarilo uložiť.",
          type: "error",
        });
      } finally {
        this.quickSettingsLoading = false;
      }
    },
    async toggleLtv90() {
      if (this.hasAutomaticLtv90 || this.ltv90Changes.length === 0) return;

      const selected = new Set(this.ratesGetter || []);
      const shouldApply = !this.isManualLtv90Active;
      for (const change of this.ltv90Changes) {
        if (shouldApply) selected.add(change.id);
        else selected.delete(change.id);
      }

      await this.saveQuickSettings(
        {uplatnene_zmeny_sadzieb: [...selected]},
        shouldApply
          ? "90 % LTV prirážky boli zapnuté vo všetkých dostupných bankách."
          : "Hromadné 90 % LTV prirážky boli vypnuté.",
      );
    },
    async toggleBankAccount() {
      const shouldUseAccount = !this.usesBankAccount;
      const selected = new Set(this.ratesGetter || []);

      // Account changes are derived from the boolean by the API. Remove any
      // legacy manual IDs so toggling the account cannot discard a campaign
      // through the mutually-exclusive campaign signal.
      for (const change of this.accountChanges) {
        selected.delete(change.id);
      }

      await this.saveQuickSettings(
        {
          vyuzitie_uctu_od_banky: shouldUseAccount,
          uplatnene_zmeny_sadzieb: [...selected],
        },
        shouldUseAccount
          ? "Používanie účtu bolo zohľadnené vo všetkých ponukách."
          : "Ponuky boli prepočítané bez používania účtu.",
      );
    },
    toggleInsuranceProduct(product) {
      const enabled = !this.mortgageGetter[product.field];
      const object = {[product.field]: enabled};
      // The API derives product discounts from the flag; clear legacy IDs
      // without adding IDs that could remove an unrelated selected campaign.
      const productIds = new Set(this.allAvailableRateChanges.filter(change => change.typ === product.type).map(change => change.id));
      object.uplatnene_zmeny_sadzieb = (this.ratesGetter || []).filter(id => !productIds.has(id));
      return this.saveQuickSettings(object, enabled
        ? `${product.label}: dostupné zľavy boli automaticky započítané do ponúk.`
        : `Ponuky boli prepočítané bez produktu: ${product.label}.`);
    },
    handleScroll() {
      // Set the 'isSticky' property based on the scroll position
      this.isSticky = window.scrollY > this.navbarOffset;
    },
    checkIfSequenceChanged(newOffers) {
      if (!this.mortgageOffersData) return true;
      const existingOffersLength = this.mortgageOffersData.length;
      if (existingOffersLength !== newOffers.length) return true;
      for (let i = 0; i < existingOffersLength; i++) {
        const bankOnIndexNew = newOffers[i].bank.code;
        const bankOnIndexOld = this.mortgageOffersData[i].bank.code;
        if (bankOnIndexNew !== bankOnIndexOld) return true;
      }
      return false;
    },
    getSortedOffers(offers, parameter, ascending) {
      let sortedOffers = JSON.parse(JSON.stringify({offers: offers})).offers;
      if (!sortedOffers) return;
      if (ascending) {
        return sortedOffers.sort((a, b) => a[parameter] - b[parameter]);
      }
      return sortedOffers.sort((a, b) => b[parameter] - a[parameter]);
    },
    sortOffersBy(parameter) {
      this.sortParameter = parameter;
      this.mortgageOffersData = this.getSortedOffers(this.mortgageOffersData, this.sortParameter, this.ascending);
      this.ascending = !this.ascending;
    },
    a() {
      setTimeout(() => {
        this.itemData = {
          img: './image.png',
          title: 'Item Title',
          body: 'Make beautiful, animated loading skeletons that automatically adapt to your app.'
        };
      }, 1500);
    },
    getBankVarsObject() {
      if (!this.mortgageOffersData) return;
      let banksVars = {};
      const banksKeys = ["mbank", "tatra", "unicredit", "slsp", "csob", "vub", "365", "prima"];
      for (const offer of this.mortgageOffersData) {
        banksVars[offer.extra.bank_code_name] = {
          splatnost: offer.splatnost_r ? offer.splatnost_r : 40,
        };
      }
      const banksIncluded = Object.keys(banksVars);
      for (const bankKey of banksKeys) {
        if (banksIncluded.includes(bankKey)) continue;
        banksVars[bankKey] = {
          splatnost: 40,
        }
      }
      return banksVars;
    },
    createHistoryObject() {
      const currentHistory = this.mortgage.offers_filter_history;
      let newHistoryObject = null;
      if (!currentHistory) {
        const applicationData = this.$store.getters["mortgageDetailState/getOffersData"];
        const amounts = this.$store.getters["mortgageDetailState/getAmounts"];
        newHistoryObject = {
          sent: [],
          broker: {
            lastOffersSetup: this.getBankVarsObject(),
            history: [
              {
                fix: applicationData.fix ? applicationData.fix : 3,
                date: new Date().toISOString(),
                suma_bezucel: amounts.suma_bezucel ? amounts.suma_bezucel : 0,
                suma_nadobudnutie: amounts.suma_nadobudnutie ? amounts.suma_nadobudnutie : 0,
                suma_refinancovanie: amounts.suma_refinancovanie ? amounts.suma_refinancovanie : 0
              },
            ],
          },
          client: [],
        }
      } else {
        newHistoryObject = {
          sent: currentHistory.sent,
          client: currentHistory.client,
          broker: {
            lastOffersSetup: this.getBankVarsObject(),
            history:
              currentHistory.broker.history ? currentHistory.broker.history : Array.isArray(currentHistory.broker) && currentHistory.broker?.length !== 0 ? currentHistory.broker : [],
          }
        }
      }
      // console.log(newHistoryObject)
      patchMortgage({offers_filter_history: newHistoryObject}, this.mortgage.id);
    },
    // handleSadzbaChange (sadzba, key, index) {
    //   this.mortgageOffers[key][index].extra.sadzba = sadzba;
    // },
    // isPicked (application, bankKey) {
    //   const aBank = this.$store.getters["formStore/getBankByKey"](bankKey).id;
    //   const aFix = application.extra.fix;
    //   const aSplatnost = application.extra.splatnost_v_rokoch;
    //   const aSadzba = application.extra.sadzba;
    //   for (const prePicked of this.pickedApplications) {
    //     const pBank = prePicked.bank.id;
    //     const pFix = prePicked.fix;
    //     const pSadzba = prePicked.sadzba_pozadovana;
    //     const pSplatnost = prePicked.splatnost;
    //     // console.log({aBank, aFix, aSadzba, aSplatnost}, {pBank, pFix, pSadzba, pSplatnost});
    //     if (aBank === pBank && aSadzba === pSadzba && aFix === pFix && aSplatnost === pSplatnost) return true;
    //   }
    //   return false;
    // },
  },
  data: () => ({
    sortParameter: null,
    ascending: false,
    itemData: {},
    pickedApplications: [],
    mortgageOffersData: [],
    loading: false,
    quickSettingsLoading: false,
    isSticky: false,
    navbarOffset: 0
  }),
};
</script>

<style lang="scss" scoped>
.offers-heading {
  display: flex;
  margin: 18px 0 8px;
  padding: 0 4px;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}

.offers-heading__title {
  color: var(--app-text);
  font-size: 15px;
  font-weight: 800;
}

.offers-heading__description {
  margin-top: 2px;
  color: var(--app-text-muted);
  font-size: 10px;
}

.offers-heading__count {
  flex: 0 0 auto;
  padding: 7px 10px;
  border: 1px solid var(--app-border);
  border-radius: 10px;
  background: var(--app-surface-muted);
  color: var(--app-text-muted);
  font-size: 9px;
  font-weight: 700;
}

.quick-offer-settings {
  display: flex;
  margin: 10px 0 8px;
  padding: 12px;
  align-items: center;
  flex-wrap: wrap;
  gap: 9px;
  border: 1px solid var(--app-border);
  border-radius: 12px;
  background: var(--app-surface-muted);
}

.quick-offer-settings__intro {
  display: flex;
  min-width: 210px;
  margin-right: 4px;
  flex: 1 1 260px;
  flex-direction: column;
  color: var(--app-text);
  font-size: 10px;
}

.quick-offer-settings__intro strong {
  font-size: 11px;
  font-weight: 900;
}

.quick-offer-settings__intro span {
  margin-top: 2px;
  color: var(--app-text-muted);
  font-size: 9px;
}

.quick-setting-button {
  display: inline-flex;
  min-height: 44px;
  padding: 7px 11px;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--app-border);
  border-radius: 10px;
  background: var(--app-surface);
  color: var(--app-text);
  text-align: left;
  cursor: pointer;
}

.quick-setting-button:hover:not(:disabled) {
  border-color: var(--app-primary);
  background: var(--app-primary-soft);
}

.quick-setting-button:disabled {
  cursor: not-allowed;
  opacity: 0.68;
}

.quick-setting-button--active {
  border-color: var(--app-primary);
  background: var(--app-primary-soft);
  color: var(--app-primary);
}

.quick-setting-button__status {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--app-surface-muted);
  color: var(--app-primary);
  font-size: 13px;
  font-weight: 900;
}

.quick-setting-button strong,
.quick-setting-button small {
  display: block;
}

.quick-setting-button strong {
  font-size: 10px;
  font-weight: 900;
}

.quick-setting-button small {
  margin-top: 1px;
  color: var(--app-text-muted);
  font-size: 8px;
}

.results-legend {
  margin: 8px 0 10px;
  padding: 10px 20px;
  border-radius: 11px;
  color: var(--app-text-muted);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.offers-empty-state {
  display: flex;
  min-height: 150px;
  margin: 8px 0 28px;
  padding: 24px;
  align-items: flex-start;
  gap: 14px;
  border: 1px solid color-mix(in srgb, var(--app-primary) 28%, var(--app-border));
  border-radius: 14px;
  background: color-mix(in srgb, var(--app-primary) 7%, var(--app-surface));
  color: var(--app-text);
  box-sizing: border-box;
}

.offers-empty-state--error {
  border-color: color-mix(in srgb, #ff856f 45%, var(--app-border));
  background:
    radial-gradient(circle at 0 0, rgba(255, 133, 111, 0.13), transparent 42%),
    var(--app-surface);
}

.offers-empty-state__icon {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  place-items: center;
  border-radius: 50%;
  background: var(--app-primary);
  color: white;
  font-size: 16px;
  font-weight: 900;
}

.offers-empty-state--error .offers-empty-state__icon {
  background: rgba(255, 133, 111, 0.16);
  color: #ff8e79;
}

.offers-empty-state__content {
  max-width: 760px;
}

.offers-empty-state__eyebrow {
  display: block;
  margin-bottom: 4px;
  color: #ff9b89;
  font-size: 8px;
  font-weight: 900;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.offers-empty-state__content strong {
  font-size: 13px;
  font-weight: 900;
}

.offers-empty-state__content p,
.offers-empty-state__content ul {
  margin: 6px 0 0;
  color: var(--app-text-muted);
  font-size: 10px;
  line-height: 1.55;
}

.offers-empty-state__content ul {
  padding-left: 18px;
}

.offers-empty-state__retry {
  margin-top: 14px;
  padding: 8px 13px;
  border: 1px solid color-mix(in srgb, var(--app-primary) 55%, var(--app-border));
  border-radius: 9px;
  background: var(--app-primary);
  color: white;
  font-size: 9px;
  font-weight: 800;
  cursor: pointer;
}

.offers-empty-state__retry:hover:not(:disabled) {
  filter: brightness(1.08);
}

.offers-empty-state__retry:disabled {
  cursor: wait;
  opacity: 0.65;
}

.display-sort {
  display: none;
}

.rotate-up {
  transform: rotate(360deg);
  width: 20px;
  height: 20px;
}

.rotate-down {
  transform: rotate(-180deg);
  width: 20px;
  height: 20px;
}

.sort-button:hover {
  & .display-sort {
    display: inline-block;
    align-items: center;
  }
}

.result-block-broker-app {
  height: 100%;
}
.sticky {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-radius: 0;
  background-color: color-mix(in srgb, var(--app-surface) 92%, transparent);
  color: var(--app-text);
  box-shadow: var(--app-shadow);
  backdrop-filter: blur(14px);
  z-index: 1000;
}
</style>
